// Email service using Resend via PHP backend

const API_URL = process.env.NODE_ENV === 'production'
  ? '/api/email.php'
  : 'http://localhost:8888/api/email.php';

// Send booking confirmation emails (customer + admin)
export const sendBookingEmails = async (bookingData, bookingId) => {
  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ bookingData, bookingId }),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error sending emails:', error);
    return { success: false, error: error.message };
  }
};

// Legacy exports for backwards compatibility
export const sendCustomerConfirmation = async (bookingData, bookingId) => {
  const result = await sendBookingEmails(bookingData, bookingId);
  return result.customerEmail || { success: false };
};

export const sendAdminNotification = async (bookingData, bookingId) => {
  const result = await sendBookingEmails(bookingData, bookingId);
  return result.adminEmail || { success: false };
};
